export default "__VITE_ASSET__PvYzpupF__"